module.exports = __webpack_public_path__ + "img/gift.ef977a9e.png";